"use strict";

/*
    * This class inherits DrawFeature control. It adds a keyboard handler to manage ESCAPE
    * and DELETE key press.
    */
ALKMaps.Control.DrawFeatureOpt = ALKMaps.Class(ALKMaps.Control.DrawFeature, {
  handlers: null,
  initialize: function initialize(layer, handler, options) {
    ALKMaps.Control.DrawFeature.prototype.initialize.apply(this, [layer, handler, options]);
    // configure the keyboard handler
    var keyboardOptions = {
      keydown: this.handleKeypress
    };
    this.handlers = {
      keyboard: new ALKMaps.Handler.Keyboard(this, keyboardOptions)
    };
  },
  handleKeypress: function handleKeypress(param) {},
  activate: function activate(param) {},
  deactivate: function deactivate(param) {},

  CLASS_NAME: "ALKMaps.Control.DrawFeatureOpt"
});


// WEBPACK FOOTER //
// ./app/alkmapsExtension/controlDrawFeatureOpt.js